import React from 'react';
import { Container, Grow, Grid } from "@material-ui/core";
import useStyles from "./styles";
import Feature from './Feature/Feature';
import { CONVERTOR_HOME_PAGE_LINK, COMPRESSOR_HOME_PAGE_LINK } from "../../constants/routingLinks";

const Home = () => {
    const classes = useStyles();
    const homeFeatures = [
        { uniqueId:'1', title: "Convertors", toLink:CONVERTOR_HOME_PAGE_LINK, content: "Convert your documents to your require formats", buttonText: "Proceed to convert document"},
        { uniqueId:'2', title: "Compressors", toLink:COMPRESSOR_HOME_PAGE_LINK, content: "Compress your documents to occupy small space", buttonText: "Proceed to compress document"}
    ];

    return (
        <Grow in>
            <Container>
                <Grid className={classes.mainContainer} container justify="space-between" alignItems="stretch" spacing={3}>
                    {homeFeatures.map((feature) => (
                        <Grid key={feature.uniqueId} item xs={12} sm={6}>
                            <Feature feature={feature}/>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Grow>
    )
}

export default Home
